import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import LoadingButton from '../../components/LoadingButton'
import Grid from '@material-ui/core/Grid'
import { isEmpty } from 'lodash'
import Button from '@material-ui/core/Button'
import update from 'immutability-helper'
import InputLabel from '@material-ui/core/InputLabel'
import Input from '@material-ui/core/Input'
import FormControl from '@material-ui/core/FormControl'
import { openSnackBar } from '../../actions/snack-bar'
import PhoneInput from '../PhoneInput/index'
import { parseNumber } from 'libphonenumber-js'
import FormHelperText from '@material-ui/core/FormHelperText'
import { Typography } from '@material-ui/core'
import { createUser } from '../../actions/users'
import { toggleReferCrewDialog } from '../../actions/crew'

class ReferCrewDialog extends Component {
  constructor(props) {
    super(props)

    this.state = {
      user: {
        first_name: '',
        last_name: '',
        phone: ''
      },
      form: {},
      selectedCountry: 'US'
    }
  }
  handleClose = () => {
    this.props.dispatch(toggleReferCrewDialog())
  }
  clearState = () => {
    this.setState({
      user: {
        first_name: '',
        last_name: '',
        phone: ''
      },
      selectedCountry: 'US'
    })
  }
  setUpForm = () => {
    const form = document.getElementById('refer-crew-form')
    const inputs = form.querySelectorAll('input, textarea')
    let newState = update(this.state, {})
    if (!newState.form) {
      newState.form = {}
    }
    for (let i = 0; i < inputs.length; ++i) {
      newState.form[inputs[i].name] = { validity: inputs[i].validity }
    }
    newState.form.valid = this.formIsValid(newState.form)
    this.setState(newState)
  }
  handleInputChange = e => {
    const fieldName = e.target.name
    const value = e.target.value
    const validity = e.target.validity

    let newState = update(this.state, {
      user: {
        [fieldName]: { $set: value }
      },
      form: {
        [fieldName]: {
          validity: { $set: validity }
        }
      }
    })
    newState.form.valid = this.formIsValid(newState.form)
    this.setState(newState)
  }
  handlePhoneChange = value => {
    let validity = document.getElementById('phoneInput').validity
    if (value) {
      validity.phone = !isEmpty(parseNumber(value, this.state.selectedCountry))
    } else {
      validity.phone = false
    }
    let newState = update(this.state, {
      user: {
        phone: { $set: value }
      },
      form: {
        phone: {
          validity: { $set: validity }
        }
      }
    })
    newState.form.valid = this.formIsValid(newState.form)
    this.setState(newState)
  }
  handleCountryChange = country => {
    this.setState({ selectedCountry: country })
  }
  handleInputBlur = e => {
    const fieldName = e.target.name

    let newState = update(this.state, {
      form: {
        [fieldName]: {
          touched: { $set: true }
        }
      }
    })
    this.setState(newState)
  }
  handlePhoneBlur = e => {
    this.setState(
      update(this.state, {
        form: {
          phone: {
            touched: { $set: true }
          }
        }
      })
    )
  }
  fieldIsValid = inputName => {
    if (!isEmpty(this.state.form)) {
      if (this.state.form[inputName].touched) {
        if (inputName === 'phone') {
          return (
            this.state.form[inputName].validity.valid &&
            this.state.form[inputName].validity.phone
          )
        } else {
          return this.state.form[inputName].validity.valid
        }
      } else {
        return true
      }
    } else {
      return true
    }
  }
  formIsValid = form => {
    let formValidArray = []
    for (let key in form) {
      if (key !== 'valid') {
        formValidArray.push(form[key].validity.valid)
      }
    }
    return formValidArray.indexOf(false) === -1
  }
  submit = e => {
    if (e) {
      e.preventDefault()
    }
    this.setState({ referingCrew: true })
    this.props
      .dispatch(createUser({ ...this.state.user, referral: true }))
      .then(res => {
        this.props.dispatch(
          openSnackBar({
            message: 'This crew member has been refered and sent and invite'
          })
        )
        this.setState({ referingCrew: false })
        this.handleClose()
      })
      .catch(err => {
        if (err.hasOwnProperty('response')) {
          if (
            err.response.body.hasOwnProperty('error') &&
            err.response.body.error.sqlMessage.indexOf("for key 'phone'") > -1
          ) {
            this.props.dispatch(
              openSnackBar({
                message: 'This user has already been invited  '
              })
            )
            this.setState({ referingCrew: false })
            this.handleClose()
          } else {
            this.props.dispatch(
              openSnackBar({
                message: 'There was an error refering this crew member'
              })
            )
          }
        } else {
          this.props.dispatch(
            openSnackBar({
              message: 'There was an error refering this crew member'
            })
          )
        }
      })
  }
  render() {
    const { fullScreen, classes } = this.props
    return (
      <Fragment>
        <Dialog
          className={classes.referCrewDialog}
          fullScreen={fullScreen}
          open={this.props.open}
          onEntered={this.setUpForm}
          onClose={this.handleClose}
          onExited={this.clearState}
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            classes: {
              root: classes.dialogPaper
            }
          }}
        >
          <DialogContent className={classes.dialogContent}>
            <Typography variant="h6">Refer Crew Member</Typography>
          </DialogContent>
          <form onSubmit={this.submit} id="refer-crew-form" autoComplete="off">
            <DialogContent className={classes.dialogContent}>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <FormControl fullWidth className={classes.marginBottom}>
                    <InputLabel htmlFor="first_name">First Name *</InputLabel>
                    <Input
                      type="text"
                      fullWidth
                      name="first_name"
                      value={this.state.user.first_name}
                      onChange={this.handleInputChange}
                      id="first_name"
                      autoComplete="nope"
                      inputProps={{
                        required: true
                      }}
                    />
                    <FormHelperText error id="first_name">
                      {!this.fieldIsValid('first_name') && (
                        <span>Enter first name</span>
                      )}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <FormControl fullWidth className={classes.marginBottom}>
                    <InputLabel htmlFor="last_name">Last Name *</InputLabel>
                    <Input
                      type="text"
                      fullWidth
                      name="last_name"
                      value={this.state.user.last_name}
                      onChange={this.handleInputChange}
                      id="last_name"
                      autoComplete="nope"
                      inputProps={{
                        required: true
                      }}
                    />
                    <FormHelperText error id="first_name">
                      {!this.fieldIsValid('first_name') && (
                        <span>Enter first name</span>
                      )}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <PhoneInput
                    label="Phone *"
                    value={this.state.user.phone}
                    onChange={this.handlePhoneChange}
                    onBlur={this.handlePhoneBlur}
                    valid={this.fieldIsValid('phone')}
                    onCountryChange={this.handleCountryChange}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions
              className={classes.dialogActions}
              classes={{
                action: classes.dialogActionsAction
              }}
            >
              <Button color="primary" onClick={this.handleClose} type="button">
                Close
              </Button>
              <LoadingButton
                color="secondary"
                buttonclicked={() => this.submit()}
                working={this.state.referingCrew}
                disabled={
                  (!isEmpty(this.state.form) && !this.state.form.valid) ||
                  this.state.referingCrew
                }
                type="button"
              >
                Save
              </LoadingButton>
            </DialogActions>
          </form>
        </Dialog>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticatedUser: state.authentication.authenticatedUser,
    open: state.crew.referCrewDialogOpen
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true }),
  withMobileDialog()
)(ReferCrewDialog)
